import PubNub from 'pubnub';

export const getUserID = () => {
  if (typeof window === 'undefined') return '';

  let lsUserID = window.localStorage.getItem('lsUserID');

  if (!lsUserID) {
    lsUserID = PubNub.generateUUID();
    window.localStorage.setItem('lsUserID', lsUserID);
  }

  return lsUserID;
};
